<template>
    <div class="full-width" ref="billDetailDom" >
        <el-row :gutter="10" >
            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單單號">{{i18n.tkey("lang_bill_id")}}</span> : <span class="info-content">{{obj.commonref}}</span>
            </el-col>

<!--            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單類型">{{i18n.tkey("lang_bill_order_type")}}</span> : <span class="info-content">{{orderType}}</span>
            </el-col>-->

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者郵箱">{{i18n.tkey("lang_bill_email")}}</span> : <span class="info-content">{{obj.addinfo3}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者姓名">{{i18n.tkey("lang_bill_username")}}</span> : <span class="info-content">{{obj.name}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者電話">{{i18n.tkey("lang_bill_tel")}}</span> : <span class="info-content">{{obj.telephone}}</span>
            </el-col>
            <el-col :span="cols" class="info-parts">
              <span class="info-title" tkey="下單地址">{{i18n.tkey("lang_d_address")}}</span> : <span class="info-content">{{obj.address}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.orderno) && obj.verify == -1)">
                <span class="info-title" tkey="支付單號">{{i18n.tkey("lang_pay_no")}}</span> : <span class="info-content">{{obj.orderno}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.orderPayState) && obj.verify == -1)">
                <span class="info-title" tkey="支付狀態">{{i18n.tkey("lang_pay_state")}}</span> : <span class="info-content">{{orderPayState}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.orderdate) && obj.verify == -1)">
                <span class="info-title" tkey="支付時間">{{i18n.tkey("lang_pay_date")}}</span> : <span class="info-content">{{obj.orderdate}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.payMethod) && obj.verify == -1)">
                <span class="info-title" tkey="支付方式">{{i18n.tkey("lang_pay_method")}}</span> : <span class="info-content">{{payMethod}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.orderState) && obj.verify == -1)">
                <span class="info-title" tkey="訂單狀態">{{i18n.tkey("lang_bill_state")}}</span> : <span class="info-content">{{orderState}}</span>
            </el-col>
            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.inputdate) && obj.verify == -1)">
                <span class="info-title" tkey="下單日期">{{i18n.tkey("lang_order_date")}}</span> : <span class="info-content">{{obj.inputdate}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts"  v-if="!myUtil.isEmpty( obj.verifydate) && obj.verify == -1">
                <span class="info-title" tkey="審核通過時間">{{i18n.tkey("lang_verify_date")}}</span> : <span class="info-content">{{obj.verifydate}}</span>
            </el-col>

        </el-row>

        <div class="title-part">
            <span tkey="購買詳情">{{i18n.tkey("lang_buy_detail")}}</span>
        </div>

        <div>
            <billProductTable :boproducts="obj.boproducts" />
        </div>

      <el-col :span="cols" class="info-parts">
        <span class="info-title" tkey="總金額">{{i18n.tkey("lang_bill_total")}}</span> : <span class="info-content">{{totalNum}}</span>
      </el-col>
      <el-row >
        <el-col :span="8" >
        </el-col>
        <el-col :span="8" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)">
            <el-button v-if="obj.verify !== -1" type="success" round style="width: 100%" @click="clickVerifyBtn(obj)" >{{i18n.tkey("lang_certifie")}}</el-button>
            <el-button v-if="obj.verify === -1"  type="info" round style="width: 100%" @click="clickVerify2Btn(obj)" >{{i18n.tkey("lang_cancel_certifie")}}</el-button>
        </el-col>

<!--        <el-col :span="8" v-if="myUtil.isEmpty(props.fromdata)&&(obj.completedpayment != -1 && obj.verify != -1)">
          <paypalButton  style="margin-bottom: 5px" @click="reSubmitOrder(obj)" />

        </el-col>-->

        <el-col :span="8">
        </el-col>
      </el-row>

      <el-row class="row" style="padding: 8px;border: 1px solid #e5e5e5;" v-if="myUtil.isEmpty(props.fromdata)&&(obj.completedpayment != -1 && obj.verify != -1)">
        <el-col :span="24" style="padding-bottom: 10px;">
          <span class="info-title" tkey="支付方式">{{i18n.tkey("lang_select_pls")}}{{i18n.tkey("lang_pay_method")}}</span>
        </el-col>

        <el-col :span="24" style="padding-bottom: 10px;text-align: center;">
          <el-row style="max-width: 500px;">
          <el-col :span="6"  v-for="(v, i) in paymentList" :key="i + new Date().getTime()" style="padding-bottom: 5px;" >
            <div class=" provider" @click="chengHallPaymentType(v,i)" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
              <div class="paylogo" :data-key="`${v.paymentMethod}`" :style="{'background-image': `url(${getPaymentLogo(v)})`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
                <img v-if="v.active" style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>

              </div>
            </div>
          </el-col>
          </el-row>
        </el-col>

        <el-col :span="24" v-if="selectpayment!=null&&selectpayment.paymentMethod!='PayPal'&&selectpayment.paymentMethod=='PaymentAsia'" style="padding-bottom: 10px;text-align: center;">

          <el-row style="max-width: 500px;">
            <el-col :span="24" style="padding-bottom: 10px;">
              <span class="info-title" tkey="PaymentAsia支付方式">{{i18n.tkey("lang_select_pls")}} PaymentAsia{{i18n.tkey("lang_pay_method")}}</span>
            </el-col>
          <el-col :span="6" class="thumbnail provider" @click="chengSelectPaymentType('Fps')" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
            <div class="paylogo" data-key="Fps" :style="{'background-image': `url(${publicPath}/static/images/fps-en.png?v=20241113)`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
              <img v-if="selectPaymentAsiapayment == 'Fps'" style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>
            </div>
          </el-col>
          <el-col :span="6" class="thumbnail provider" @click="chengSelectPaymentType('Alipay')" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
            <div class="paylogo" data-key="Alipay" :style="{'background-image': `url(${publicPath}/static/images/alipay.png?v=20241113)`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
              <img v-if="selectPaymentAsiapayment == 'Alipay'" style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>
            </div>
          </el-col>
          <el-col :span="6" class="thumbnail provider" @click="chengSelectPaymentType('Wechat')" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
            <div class="paylogo" data-key="Wechat" :style="{'background-image': `url(${publicPath}/static/images/wechat-pay.png?v=20241113)`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
              <img v-if="selectPaymentAsiapayment == 'Wechat'" style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>
            </div>
          </el-col>
          <el-col :span="6" class="thumbnail provider" @click="chengSelectPaymentType('CreditCard')" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
            <div class="paylogo" data-key="CreditCard" :style="{'background-image': `url(${publicPath}/static/images/visa-master-apple-google.png?v=20241113)`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
              <img v-if="selectPaymentAsiapayment == 'CreditCard'"  style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>
            </div>
          </el-col>
          </el-row>
        </el-col>

        <el-col :span="24" v-if="selectpayment!=null&&selectpayment.paymentMethod!='PayPal'&&selectpayment.paymentMethod!='PaymentAsia'&&selectpayment.paymentMethod!='Bank Transfer'" style="padding-bottom: 10px;text-align: center;">

          <span class="info-title" tkey="請掃描QRCode支付">{{i18n.tkey("lang_scan")}} QRCode{{i18n.tkey("lang_pay_1")}}</span>
          <br>
          <img :src="`${QRImg}`" style="min-width: 100px;max-width: 50%;"/>

        </el-col>

        <el-col :span="24" v-if="selectpayment!=null&&selectpayment.paymentMethod!='PayPal'&&selectpayment.paymentMethod=='Bank Transfer'" style="padding-bottom: 10px;text-align: left;">

          <span class="info-title" tkey="請將訂單號寫入轉賬說明中">({{i18n.tkey("lang_Please_include_the_order_number_in_the_transfer_instructions")}}) </span>
          <br> <br>
          <span class="info-title" tkey="收款賬號">{{i18n.tkey("lang_revice_account")}} ：{{selectpayment.accountLogin}}</span>
<br>
          <span class="info-title" tkey="備註">{{i18n.tkey("lang_notes")}} ：{{selectpayment.sremark}}</span>

        </el-col>
        <el-col :span="24">

          <paypalForm v-if="myUtil.isNotEmpty(rePayObj)&&selectpayment!=null&&selectpayment.paymentMethod=='PayPal'" :formObj="rePayObj" @submit-complete="submitComplete" />
          <PaymentAisaForm v-if="myUtil.isNotEmpty(rePayObj)&&selectpayment!=null&&selectpayment.paymentMethod=='PaymentAsia'" ref="reAisaFormObj" :formObj="rePayObj" @submit-complete="submitComplete" />

        </el-col>
<!--        <el-col :span="24" v-if="selectpayment==null||(selectpayment!=null&&selectpayment.paymentMethod=='PayPal')||(selectpayment!=null&&selectpayment.paymentMethod=='PaymentAsia')" style="padding-bottom: 10px;text-align: center;">
          <el-button type="primary" @click="btnChagePayment()"  tkey="支付">{{i18n.tkey("lang_pay_1")}}</el-button>
        </el-col>-->
      </el-row>


    </div>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, computed, inject} from 'vue'
    import billProductTable from "@/components/shopopee/bill/billProductTable"
    import PaypalForm from "@/components/shopopee/form/paypalForm.vue";
    import PaymentAisaForm from "@/components/shopopee/form/paymentAisaForm.vue";
    import myUtil from "@/util/util";
    import record14Api from "@/request/record14Api";
    import companyApi from "@/request/companyApi";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const props = defineProps(['obj','fromdata'])
    const emits = defineEmits(["changeOrder","clickVerify" ])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const width = ref(425)
    const cols = ref(24)
    //需要重新付款的订单
    const rePayObj = ref(null)
    const rehallInof = ref(null)
    const paymentList= ref([])
    const selectpayment= ref(null)
    const selectPaymentAsiapayment= ref("")
    const ecompanyinfo = ref(null)

    const QRImg = ref(null)
    const publicPath = process.env.BASE_URL
    const totalNum = computed(() => {
        let curr = "HKD"

        if (null != props.obj.boproducts && props.obj.boproducts.length > 0){
            curr = props.obj.boproducts[0].curr
        }

        return `${props.obj.totalsum} ${curr}`
    })

    const orderState = computed(() => {
        let state = i18n.tkey("lang_under_review")  //審核中

        if (props.obj.verify == -1){
            state = i18n.tkey("lang_completed")
        }else if (props.obj.verify == 1){
            state = i18n.tkey("lang_refused")
        }

        return state
    })

    const payMethod = computed(() => {
        let name = ""

        if (props.obj.printout == 1){
            name = "paypal"
        }

        return name
    })

    const orderPayState = computed(() => {
        let payState = i18n.tkey("lang_unpaid")

        if (props.obj.completedpayment == -1){
            payState = i18n.tkey("lang_paid")
        }

        return payState
    })

    const orderType = computed(() => {
        let type = i18n.tkey("lang_item_1")

        switch (props.obj.japno) {
            case "0":
                type = i18n.tkey("lang_company_auth");
                break;

            case "1":
                type = i18n.tkey("lang_staff_num");
                break;

            case "2":
                type = i18n.tkey("lang_three_shop_exp");
                break;

            case "3":
                type = i18n.tkey("lang_buy_nfc_card");
                break;

            case "4":
                type = i18n.tkey("lang_customer_bill");
                break;
        }

        return type
    })


    function getPaymentLogo(obj){
      var imgPath = ""
      if("PayPal"===obj.paymentMethod){
        return publicPath+"static/images/paypal-payments.png?v=20241113"
      }else if("PaymentAsia"===obj.paymentMethod){
        return publicPath+"static/images/paymentAisa-payments.png?v=20241113"
      }else if("WeChat Pay"===obj.paymentMethod){
        return publicPath+"static/images/wechat-pay.png?v=20241113"
      }else if("FPS"===obj.paymentMethod){
        return publicPath+"static/images/fps-en.png?v=20241113"
      }else if("Alipay"===obj.paymentMethod){
        return publicPath+"static/images/alipay.png?v=20241113"
      }else if("Custom"===obj.paymentMethod){
        return publicPath+"static/images/visa-master-apple-google.png?v=20241113"
      }else if("Bank Transfer"===obj.paymentMethod){
        return publicPath+"static/images/visa-master-apple-google.png?v=20241113"
      }
      return imgPath
    }

    function getHallCompanyInfo(){
      const request = companyApi.getSimpleCompanyInfoByCompanycode
      const params = request.getParams()

      params.companycode = rehallInof.value.companycode

      request.send(params, (res) => {
        if (res.code == 200){
          ecompanyinfo.value = res.detail
          //acccompanycode
          getEshopopeePayments(ecompanyinfo.value.acccompanycode)

        }
      })

    }

    function getEshopopeePayments(acccompanycode){
        const request = eshopopeeApi.getPaymentList
        const params = request.getParams()
        params.CompanyCode = acccompanycode

        request.send(params, getEListCallback)
    }
    function getEListCallback(res) {
      if (myUtil.isNotEmpty(res)){
        paymentList.value = []
        for (let i = 0; i <res.length ; i++) {
          if(rehallInof.value.addinfo28.includes(res[i].paymentMethod)){
            paymentList.value.push(res[i])
          }
        }
      }else{
        paymentList.value = []
      }
    }
    function reSubmitOrder(obj){
      console.log(obj)
      let curr = obj.currinorder

      if (null != obj.boproducts && obj.boproducts.length > 0){
        curr = obj.boproducts[0].curr
      }

      rePayObj.value = {
        fromtitle: "shopopee_apply_auth_" + obj.commonref,
        fromnumber: obj.commonref,
        fromamout: obj.totalsum,
        fromcurr: curr,
        fromAccLogin:selectpayment.value.accountLogin,
        fromaddress:obj.address,
        fromemial:obj.addinfo3,
        fromname:obj.name,
        fromphone:obj.telephone,
        fromnetwork:selectPaymentAsiapayment.value,
        fromsubject: obj.commonref,
        fromaccountPassword:selectpayment.value.accountPassword,
      }
    }
    function chengSelectPaymentType(payType) {
      selectPaymentAsiapayment.value = payType
      rePayObj.value.fromnetwork = selectPaymentAsiapayment.value
      proxy.$refs.reAisaFormObj.initDataPay()
    }

    function chengHallPaymentType(v,i) {
      for (let j = 0; j < paymentList.value.length; j++) {
        paymentList.value[j].active = false
      }
        paymentList.value[i].active = true
        selectpayment.value = paymentList.value[i]
      if(selectpayment.value!=null&&selectpayment.value.paymentMethod!='PayPal'&&selectpayment.value.paymentMethod!='PaymentAsia'&&selectpayment.value.paymentMethod!='Bank Transfer'){
        QRImg.value = `${proxy.$SSL}://${proxy.$EShopopeeUrl}/MPic/${ecompanyinfo.value.acccompanycode}/Pa/${selectpayment.value.id.substring(0, 2)}/${selectpayment.value.id}.jpg`
      }
      selectPaymentAsiapayment.value = ""
      reSubmitOrder(props.obj)
    }
    function clickVerifyBtn(obj){
      emits("clickVerify", obj, -1)
    }

    function clickVerify2Btn(obj){

      emits("clickVerify", obj, 0)
    }

    function submitComplete(){
      rePayObj.value = null
      setTimeout(() => {
        emits("changeOrder",props.obj.id)
      }, 30000)
    }

    function getHallInfo(){
      const request = record14Api.getRecord14List
      const params = request.getParams()
      params.id = props.obj.orderref

      request.send(params, (res) => {
        if (res.code == 200){
          if (null != res.detail && res.detail.length > 0){
            rehallInof.value = res.detail[0]
            getHallCompanyInfo()
          }
        }else{
          myUtil.alertError(res.msg)
        }
      })
    }

    onMounted(() => {
        width.value = proxy.$refs.billDetailDom.offsetWidth

        if (width.value > 768){
            cols.value = 12
        }
        if(myUtil.isNotEmpty(props.obj.orderref)){
          getHallInfo()
        }
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
      margin-bottom: 20px;
    }

    .title-part {
        text-align: left;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .info-parts {
        padding: 10px;
        text-align: left;
        font-size: 15px;
    }

    .info-title {
        color: #606266;
    }

    .info-content {
        color: #606266;
    }

    .paylogo{
      display: flex;
    }


    .provider.active {
      border: 1px solid #b9d4e9 !important;
      background-color: #e0eef2 !important;
    }
</style>